import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { exists } from '../../../../../../../functions/exists';
import { PlantlifeBusinessCardStackSharedLogicContentViewModel } from './plantlife-business-card-stack-shared-logic-content-view-model';

@Component({ template: '' })
export abstract class PlantlifeBusinessCardStackSharedLogicContentComponent
  extends PrintCardContentComponent
  implements AfterViewInit, OnDestroy
{
  constructor(
    override viewModel: PlantlifeBusinessCardStackSharedLogicContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @ViewChild('titleContainer') titleContainer: ElementRef<HTMLDivElement>;
  private titleContainerStyleMutationObserver: MutationObserver;

  private BADGE_TITLE_HEIGHT_PX_RATIO = 13 / 22;

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.listenToChangesInTitleText();
  }

  private listenToChangesInTitleText() {
    const titleContainerMutationConfig = {
      attributes: true,
      attributeFilter: ['style'],
      childList: false,
      subtree: true
    };
    if (exists(this.titleContainer)) {
      this.titleContainerStyleMutationObserver = new MutationObserver(this.adjustBadgeSize);
      this.titleContainerStyleMutationObserver.observe(
        this.titleContainer?.nativeElement,
        titleContainerMutationConfig
      );
    }
  }

  private adjustBadgeSize = (): void => {
    const element = this.titleContainer?.nativeElement;
    if (!element) {
      // Element is missing; keep the existing/default badge height.
      return;
    }
    const computedStyle = getComputedStyle(element);
    const fontSizeString = computedStyle?.fontSize;
    const fontSize = fontSizeString !== null ? parseFloat(fontSizeString?.replace('px', '')) : NaN;
    if (Number.isNaN(fontSize)) {
      // Could not parse a valid font size; keep the existing/default badge height.
      return;
    }
    this.viewModel.connectToBadgesInlineWithTitleHeight(Math.floor(fontSize * this.BADGE_TITLE_HEIGHT_PX_RATIO));
  };

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.titleContainerStyleMutationObserver?.disconnect();
  }
}
